<!-- Footer and copyright-->
<footer class="page-footer grey lighten-2">
    <div class="container">
        <div class="row">
            <div class="col l6 s12">
                <h5 class="footer-text">Colaboração:</h5>
                <a href="https://www.ufpe.br"><img class="responsive-img" src="assets\logos\ufpe.png"></a>
                <img class="responsive-img" src="assets\logos\lab.png">
            </div>
            <div class="col l4 offset-l2 s12">
                <h5 class="footer-text">Em Parceria:</h5>
                <a href="http://www.cultura.pe.gov.br/"><img class="responsive-img funcultura"
                        src="assets\logos\funcultura_cor.png"></a>
            </div>
        </div>
    </div>
    <div class="footer-copyright">
        <div class="container footer-text">
            © 2022 Nutrientes Criativos
            <a class="footer-text text-lighten-4 right" href="#!">Mais links</a>
        </div>
    </div>
</footer>